import { useHasFeatureFlag } from 'featureFlags/useHasFeatureFlag.ts';
import { useHasInLifePermissions } from 'products/common/actions/useHasInLifePermissions.ts';

export const useIsSimInLifeChangesAvailable = () => {
  const hasPermission = useHasInLifePermissions();
  const inlifeChangesEnabled = useHasFeatureFlag('SimProductInLifeChanges');

  return hasPermission && inlifeChangesEnabled;
};
